export default "__VITE_ASSET__FwMC8hFE__"